<template>
  <div class="container">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getMobileLiveList()"
    >
      <div v-for="(item, index) in list" :key="index">
        <div class="nowDay">{{ item.Date }}</div>
        <div class="listBox">
          <div v-for="(sitem, sindex) in item.List" :key="sindex">
            <div class="liveItem">
              <mini-program
                :path="
                  '/subpackagelive/pages/liveDetail/liveDetail?id=' +
                  item.LiveId
                "
              >
                <van-image fit="cover" :src="sitem.Cover" />
                <div class="liveStatus">{{ sitem.StartTimeDesc }}</div>
                <div class="rightBox">
                  <div class="title overFlowTwo">{{ sitem.Title }}</div>
                  <div class="storeBox">
                    <van-image
                      fit="cover"
                      :src="sitem.HeadlineLogo"
                      round
                      error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                    />
                    <div class="name overFlowOne">{{ sitem.Headline }}</div>
                    <div class="visitBtn">预约</div>
                  </div>
                </div>
              </mini-program>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { List, Image } from "vant";
import { getShareData } from "@/utils/share";
import miniProgram from "@/components/miniProgram";
import { mobileLiveListOrderTime } from "@/api/online";
export default {
  name: "livePreview",
  components: {
    "van-list": List,
    "van-image": Image,
    miniProgram,
  },
  data() {
    return {
      list: [],
      pageIndex: 1,
      total: 0,
      error: false,
      loading: false,
      finished: false,
    };
  },
  methods: {
    getMobileLiveList() {
      var that = this;
      var data = {
        CategoryId: 0,
        MemberId: 0,
        Keyword: "",
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
        Recommend: -1,
        SpecialId: -1,
        HasQrcode: 1,
        Status: 1,
      };
      mobileLiveListOrderTime(data)
        .then((res) => {
          var list = res.Data.List;
          list.forEach((item, index) => {
            item.List.forEach((sitem, sindex) => {
              sitem.StartTimeDesc = sitem.StartTimeDesc.substr(10);
            });
          });
          if (list.length == 0) return;
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            // 取出先有列表最后一个日期数组
            var end = that.list.pop();
            // 取出新列表第一个日期数组
            var start = list.shift();
            //同一个日期则拼接日期内数据
            if (start.Date === end.Date) {
              end.List = end.List.concat(start.List);
              that.list.push(end);
              that.list = [...that.list, ...list];
            } else {
              //不是同一个日期则直接拼接
              that.list.push(end);
              that.list.push(start);
              that.list = [...that.list, ...list];
            }
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          var total = 0;
          that.list.forEach((element) => {
            total += element.List.length;
          });
          if (total >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  mounted() {
    getShareData(window.location.href, "2022阿拉丁网上照明展直播预告");
  },
};
</script>
<style lang="less" scoped>
.container {
  padding: 10px 0px;
  background-color: #efefef;
  .nowDay {
    color: #333;
    font-size: 15px;
    margin: 0px 0px 10px 9px;
  }
  .listBox {
    background-color: #fff;
    margin-bottom: 10px;
  }
}
</style>
